import { createRouter, createWebHashHistory } from 'vue-router'

import { useAuthStore } from '@/store/auth'
import { pinia } from '@/store/pinia'
import { useStatusStore } from '@/store/status'

import { routes } from './routes'

export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach(to => {
  const auth = useAuthStore(pinia)
  const status = useStatusStore(pinia)
  const needsAuth =
    !['login', 'signUp', 'redirectLogin', 'supportLogin', 'newPassword'].includes(
      to.name?.toString() || ''
    ) &&
    !['/pos/login', '/pos/signUp', '/redirect-login', '/support-login', '/new-password'].includes(
      to.path
    )
  const isAuthenticated = auth.isAuthenticated
  const gracePeriodExpired = auth.gracePeriodExpired
  const trialExpired = auth.trialExpired
  const hasTimeError = status.hasTimeError

  if (needsAuth && !isAuthenticated) {
    return {
      name: 'login'
    }
  } else if (needsAuth && gracePeriodExpired && to.name !== 'gracePeriodExpired') {
    return {
      name: 'gracePeriodExpired'
    }
  } else if (needsAuth && trialExpired && to.name !== 'freeTrialExpired') {
    return {
      name: 'freeTrialExpired'
    }
  } else if (hasTimeError && to.name !== 'wrongTime') {
    return {
      name: 'wrongTime'
    }
  }
})
